(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kava-gallery-emily-01"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function(){
  var images = [];
  var currentIndex = 0;
  
  // 收集所有使用 data-lightbox 属性的链接
  document.querySelectorAll('a[data-lightbox^="gallery-"]').forEach(function(anchor, idx){
    images.push(anchor.href);
    anchor.addEventListener('click', function(e){
      e.preventDefault();
      currentIndex = idx;
      openLightbox();
    });
  });
  
  function openLightbox(){
    var lightbox = document.getElementById('custom-lightbox');
    if(!lightbox){
      lightbox = document.createElement('div');
      lightbox.id = 'custom-lightbox';
      lightbox.innerHTML = `
        <button class="close-btn">×</button>
        <button class="nav-btn prev-btn">&#10094;</button>
        <img src="" alt="Preview">
        <button class="nav-btn next-btn">&#10095;</button>
      `;
      document.body.appendChild(lightbox);
      
      lightbox.querySelector('.close-btn').addEventListener('click', closeLightbox);
      lightbox.querySelector('.prev-btn').addEventListener('click', showPrev);
      lightbox.querySelector('.next-btn').addEventListener('click', showNext);
      lightbox.addEventListener('click', function(e){
        if(e.target === lightbox) closeLightbox();
      });
      
      var lightboxImg = lightbox.querySelector('img');
      // 修改点击事件：逐级放大及复位
      lightboxImg.addEventListener('click', function(e) {
        e.stopPropagation();
        // 获取当前 zoomLevel，初始为1
        var zoom = parseFloat(lightboxImg.dataset.zoomLevel || 1);
        if (zoom === 1) {
          zoom = 1.5;
        } else if (zoom < 2.25) {
          zoom = zoom * 1.5;
        } else {
          zoom = 1;
        }
        lightboxImg.dataset.zoomLevel = zoom;
        if (zoom === 1) {
          lightboxImg.classList.remove('zoomed');
          lightboxImg.style.transform = 'none';
        } else {
          lightboxImg.classList.add('zoomed');
          // 重置平移参数
          lightboxImg.dataset.translateX = 0;
          lightboxImg.dataset.translateY = 0;
          lightboxImg.style.transform = 'scale(' + zoom + ')';
        }
      });
      
      // 新增拖拽支持 - 桌面端
      var isDragging = false, startX, startY;
      lightboxImg.addEventListener('mousedown', function(e){
        if(lightboxImg.dataset.zoomLevel == 1) return;
        isDragging = true;
        startX = e.clientX;
        startY = e.clientY;
        e.preventDefault();
      });
      document.addEventListener('mousemove', function(e){
        if(!isDragging) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        var tx = parseFloat(lightboxImg.dataset.translateX || 0) + dx;
        var ty = parseFloat(lightboxImg.dataset.translateY || 0) + dy;
        lightboxImg.dataset.translateX = tx;
        lightboxImg.dataset.translateY = ty;
        var zoom = parseFloat(lightboxImg.dataset.zoomLevel || 1);
        lightboxImg.style.transform = 'scale(' + zoom + ') translate(' + tx + 'px, ' + ty + 'px)';
        startX = e.clientX;
        startY = e.clientY;
      });
      document.addEventListener('mouseup', function(){
        isDragging = false;
      });
      
      // 新增拖拽支持 - 手机端
      lightboxImg.addEventListener('touchstart', function(e){
        if(lightboxImg.dataset.zoomLevel == 1) return;
        isDragging = true;
        var touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
      });
      lightboxImg.addEventListener('touchmove', function(e){
        if(!isDragging) return;
        var touch = e.touches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;
        var tx = parseFloat(lightboxImg.dataset.translateX || 0) + dx;
        var ty = parseFloat(lightboxImg.dataset.translateY || 0) + dy;
        lightboxImg.dataset.translateX = tx;
        lightboxImg.dataset.translateY = ty;
        var zoom = parseFloat(lightboxImg.dataset.zoomLevel || 1);
        lightboxImg.style.transform = 'scale(' + zoom + ') translate(' + tx + 'px, ' + ty + 'px)';
        startX = touch.clientX;
        startY = touch.clientY;
        e.preventDefault();
      });
      lightboxImg.addEventListener('touchend', function(){
        isDragging = false;
      });
    }
    lightbox.classList.add('active');
    updateLightboxImage();
  }
  
  function closeLightbox(){
    var lightbox = document.getElementById('custom-lightbox');
    if(lightbox){
      lightbox.classList.remove('active');
    }
  }
  
  function updateLightboxImage(){
    var lightbox = document.getElementById('custom-lightbox');
    var img = lightbox.querySelector('img');
    img.src = images[currentIndex];
    // 重置状态及 zoomLevel
    img.classList.remove('zoomed');
    img.style.transform = 'none';
    img.dataset.translateX = 0;
    img.dataset.translateY = 0;
    img.dataset.zoomLevel = 1;
  }
  
  function showPrev(e){
    e.stopPropagation();
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    updateLightboxImage();
  }
  
  function showNext(e){
    e.stopPropagation();
    currentIndex = (currentIndex + 1) % images.length;
    updateLightboxImage();
  }
});

  } catch(e) { console.error(e); }
})();
})();
